var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.5V14.5H10.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30.5V21.5H25.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.735 13.5004C29.9742 11.3505 28.6813 9.42846 26.9768 7.91348C25.2723 6.39851 23.2118 5.34001 20.9876 4.83674C18.7633 4.33348 16.4479 4.40187 14.2572 5.03552C12.0666 5.66917 10.0721 6.84743 8.46 8.46036L2 14.5M33.5 21.5L27.54 27.5404C25.9279 29.1533 23.9334 30.3315 21.7428 30.9652C19.5521 31.5988 17.2367 31.6672 15.0124 31.164C12.7882 30.6607 10.7277 29.6022 9.0232 28.0872C7.3187 26.5723 6.02575 24.6502 5.265 22.5004",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurItem);
export default __webpack_public_path__ + "static/media/recur-item.fc9f1e301eb522527371942199ffd5fa.svg";
export { ForwardRef as ReactComponent };